<template>
  <v-dialog
    v-model="widgetDialogFullscreen"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="metricWidget"
  >
    <v-card>
      <v-toolbar dark color="secondary">
        <v-toolbar-title
          ><h3>{{ metricWidget.metric.name }}</h3></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click.stop="dismissFullscreen()">
            <v-icon>fullscreen_exit</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <component
        :is="getComponent(metricWidget.type)"
        :metricWidget=metricWidget
        :fullscreen=widgetDialogFullscreen
      />      
    </v-card>
  </v-dialog>
</template>

<script>
import NumberWidget from "@/components/metrics/NumberWidget.vue"
import TrendlineWidget from "@/components/metrics/TrendlineWidget.vue"
import PiechartWidget from "@/components/metrics/PiechartWidget.vue"

export default {
  name: 'FullScreenWidget',
  props: {
    metricWidget: {
      type: Object
    },
    widgetDialogFullscreen: {
      type: Boolean
    }
  },
  methods: {
    getComponent(component) {
      switch (component) {
        case "number":
          return NumberWidget;
        case "trend":
          return TrendlineWidget;
        case "piechart":
          return PiechartWidget;
      }
    },
    dismissFullscreen() {
      this.$emit('dismiss-fullscreen')
    }
  },


  
}
</script>